<template>
  <section class="header-image" :style="'background-image: url(' + image+ ');'">
    <h1 v-html="title"></h1>
  </section>
</template>

<script>
  export default {
    props: {
      title: { type: String },
      image: { type: String },
    },
  }
</script>

<style lang="scss" scoped>

  .header-image {
    @include background-cover();
    padding: 275px 45px 40px;
    position: relative;
    overflow: hidden;
    @media (max-width: 900px) {
      padding: 255px 25px 25px;
    }
    @media (max-width: 600px) {
      padding: 25px 15px 25px;
    }
    h1 {
      color: #fff;
      padding: 0;
      z-index: 1;
      position: relative;
      @media (max-width: 500px) {
        @include font-size(26px, 32px);
      }
    }
    &:after {
      @include pseudo;
      @include size(100%, 50%);
      @include linear-gradient(to top, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0) 100%);
      z-index: 0;
      min-height: 300px;
      bottom: 0;
      left: 0;
    }
  }
</style>


// WEBPACK FOOTER //
// components/header/HeaderImage.vue